import { App, Typography } from 'antd';
import { ActionsDropdown } from '@/shared/components/ActionsDropdown';
import { useDeleteRule, useRestoreRule } from '@/features/agreements/hooks/useRules';
import { getErrorMessage } from '@/shared/utils/errors/getErrorMessage';
import { getToggleActiveMenuItem } from '@/shared/utils/menuItems/getToggleActiveMenuItem';

const { Text } = Typography;

export const RuleActionsDropdown = ({ rule, ruleGroup, onChange }) => {
  const { notification } = App.useApp();

  const deleteRuleMutation = useDeleteRule();
  const restoreRuleMutation = useRestoreRule();

  const handleActivateRule = () => {
    restoreRuleMutation.mutate({ ruleGroupId: ruleGroup.id, ruleId: rule.id }, {
      onSuccess: () => {
        // Llamar onChange para notificar al componente padre del cambio
        onChange?.();
        notification.success({
          message: <Text strong>Condición activada</Text>,
          description: '¡La condición se ha activado correctamente!',
        });
      },
      onError: (error) => {
        notification.error({
          message: <Text strong>Condición no activada</Text>,
          description: getErrorMessage(error),
        });
      },
    });
  };

  const handleInactivateRule = () => {
    deleteRuleMutation.mutate({ ruleGroupId: ruleGroup.id, ruleId: rule.id }, {
      onSuccess: () => {
        // Llamar onChange para notificar al componente padre del cambio
        onChange?.();
        notification.success({
          message: <Text strong>Condición inactivada</Text>,
          description: '¡La condición se ha inactivado correctamente!',
        });
      },
      onError: (error) => {
        notification.error({
          message: <Text strong>Condición no inactivada</Text>,
          description: getErrorMessage(error),
        });
      },
    });
  };

  const actions = {
    activate: {
      handler: handleActivateRule,
      loading: restoreRuleMutation.isPending,
    },
    inactivate: {
      handler: handleInactivateRule,
      loading: deleteRuleMutation.isPending,
    },
  };

  const menuItems = [
    getToggleActiveMenuItem({
      record: rule,
      onActivate: actions.activate.handler,
      onInactivate: actions.inactivate.handler,
      loading: actions.activate.loading || actions.inactivate.loading,
    }),
  ];

  return <ActionsDropdown items={menuItems} />;
};
